import styled from "styled-components";
import { appearFromLeft } from "../Create/1-Layout/styles";
import { Image } from "antd";

export const FinishedContainer = styled.div`
  margin: 0px 24px;
  overflow-y: auto;
  flex: 1;

  animation: ${appearFromLeft} 1s;
`;

export const SquareImg = styled(Image)`
  aspect-ratio: 1080 / 1350;
  object-fit: cover;
  object-position: top;
  width: 384px;
`;

export const VRImg = styled(Image)`
  aspect-ratio: 9 / 16;
  width: 270.33px;
`;

export const HRImg = styled(Image)`
  aspect-ratio: 300 / 157;
  width: 670px;
`;
